// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"6908b4ab","355":"60845bf2","380":"b42fcca5","487":"141f4604"}[chunkId] + ".css";
};